export default "__VITE_ASSET__KkdbWus1__"